module.exports = __webpack_public_path__ + "img/5_2022TerryFoxRun_WomenPerformanceTShirt_Thumbnail.93bc24b8.png";